export default __webpack_public_path__ + "static/media/gg.df2355b9.svg";